// extracted by mini-css-extract-plugin
export default {"serviceWrapper":"services_serviceWrapper__S-NRL","sectionContainer":"services_sectionContainer__PhgFJ","visible":"services_visible__8guyj"};